export default __webpack_public_path__ + "static/media/pushpayInternship.01bba2f1.jpg";